import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { Callout } from '@liveauctioneers/hammer-ui-core/callout';
import {
    CloseButton,
    ModalActions,
    ModalContent,
    ModalHeader,
    ModalTitle,
} from '@liveauctioneers/hammer-ui-core/modal/components';
import { Modal } from '@liveauctioneers/hammer-ui-core/modal';

type SwitchCompanyUnsavedModalProps = Readonly<{
    onCancel: () => void;
    onConfirm: () => void;
    show: boolean;
    targetCompanyName: string;
}>;

export const SwitchCompanyUnsavedModal = ({
    onCancel,
    onConfirm,
    show,
    targetCompanyName,
}: SwitchCompanyUnsavedModalProps) => (
    <Modal
        handleClose={onCancel}
        show={show}
        type="composable"
    >
        <CloseButton />
        <ModalHeader className="shadow-none">
            <ModalTitle>Enter {targetCompanyName}?</ModalTitle>
        </ModalHeader>
        <ModalContent>
            <Callout
                message="Any unsaved changes will not be saved if you proceed."
                status="info"
            />
        </ModalContent>
        <ModalActions>
            <div className="flex w-full flex-row items-center justify-center gap-sm">
                <Button
                    className="w-[158px]"
                    data-testid="switch-company-cancel-button"
                    onClick={onCancel}
                    type="button"
                    variant="outlined"
                >
                    Cancel
                </Button>
                <Button
                    className="w-[158px]"
                    data-testid="switch-company-proceed-button"
                    onClick={onConfirm}
                    type="button"
                >
                    Proceed
                </Button>
            </div>
        </ModalActions>
    </Modal>
);

SwitchCompanyUnsavedModal.displayName = 'SwitchCompanyUnsavedModal';
